<template>
	<nuxt-link :class="{ 'large-icon': large }" class="profile-button" to="/profile/account/">
		<logo-icon :large="large" :custom-sizes="customSizes" :src="userTeam.logo" full />
	</nuxt-link>
</template>

<script>
import { mapGetters } from 'vuex'
import { LogoIcon } from '~/components/particles'

export default {
	name: 'ProfileButton',
	components: { LogoIcon },
	props: {
		large: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			customSizes: {
				width: 35,
				height: 35
			}
		}
	},
	computed: {
		...mapGetters({ userTeam: 'teams/selectedTeam' })
	}
}
</script>

<style lang="scss">
	@import "assets/scss/base/basics";

	.profile-button {
		@extend %button;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 60px;
		width: 60px;
		padding: 0;
		background-color: $white;
		border: 1px solid #c4c4c4;
		border-radius: 50px;
		color: $secondary;

		&.large-icon {
			height: 200px;
			width: 200px;
			border-radius: 50%;
		}
	}
</style>
